import { Component, OnInit, Input, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';

@Component({
  selector: 's1-input-text',
  templateUrl: './s1-input-text.component.html',
  styleUrls: ['./s1-input-text.component.scss']
})
export class S1InputText implements OnInit {

  @Input() control: UntypedFormControl;
  @Input() label: string = '';
  @Input() readonly: boolean = false;
  @Input() type: string = 'text';
  @Input() isValid: boolean = true;
  @Input() customClass: string = '';
  @Input() maxLength: number;
  @Input() minLength: number;
  @Input() append: string = '';

  @ViewChild('input') input: ElementRef;

  Validators = Validators;

  constructor() { }

  ngOnInit(): void { }

  checkIsValid(): boolean {

    return this.control.valid || !this.control.touched;

  }

  focus() {
    this.input.nativeElement.focus();
  }

}
